import { render, staticRenderFns } from "./NotImplemented.vue?vue&type=template&id=1fc87da8&scoped=true&"
import script from "./NotImplemented.vue?vue&type=script&lang=js&"
export * from "./NotImplemented.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc87da8",
  null
  
)

export default component.exports